import { type ComponentType, ReactNode } from 'react';

import { type LinkProps } from '@backstage/core-components';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from './render-extension';

export type ResourceLinkAttributes = Partial<Pick<LinkProps, 'target' | 'rel'>>;

export interface ResourceLinkOptions extends ResourceLinkAttributes {
  name: string;
  text: ReactNode;
  className?: string;
}

export type ResourceDisplayNameProps = {
  name: string;
  children: ReactNode;
};

export type ResourceLinkIcon =
  | 'chat'
  | 'entity'
  | 'factTable'
  | 'flag'
  | 'identity'
  | 'measurement'
  | 'metric'
  | 'project'
  | 'recording'
  | 'surface'
  | 'workflow';

export type ResourceLinkExtensionOptions =
  ItemRenderExtensionOptions<ResourceLinkOptions> & {
    DisplayName?: ComponentType<ResourceDisplayNameProps>;
    icon?: ResourceLinkIcon;
  };

export const ResourceLinkExtensions =
  createItemRenderExtensions<ResourceLinkExtensionOptions>({
    id: 'resource-link',
  });

export const createResourceLinkExtension = (
  options: ResourceLinkExtensionOptions,
) => {
  return createItemRenderExtension<ResourceLinkExtensionOptions>(options);
};

export const useResourceLinkExtensions = (): ResourceLinkExtensionOptions[] =>
  useItemRenderExtensions<ResourceLinkExtensionOptions>(ResourceLinkExtensions);
